import React from 'react';
import {Img} from 'views/AppElements';



const UserAvatar = ({user}) => {
	if(!user)
		return <div className="userAvatar flexRow">
				<Img className="avatarLoader" />
			</div>;

	const profilePicture = user.profilePicture;
	const userId = user.id;
	const userTitle = user.storeName? user.storeName.toUpperCase(): user.username;

	const LetterAvatar = ({userTitle}) => {
		return <div className="letterAvatar">{userTitle.toUpperCase().charAt(0)}</div>
	};
	const ImgAvatar = ({profilePicture, userId}) => {
		return <Img src={profilePicture} key={userId} />
	}

	const avatar = profilePicture? <ImgAvatar profilePicture={profilePicture} userId={userId} />: 
									<LetterAvatar userTitle={userTitle} />

	return <div className="userAvatar flexRow">
		{avatar}
	</div>
};

export default UserAvatar;


// WEBPACK FOOTER //
// ./src/views/user/UserAvatar.js